import { render, staticRenderFns } from "./SettingAutoLikedTop.vue?vue&type=template&id=629d31de"
import script from "./SettingAutoLikedTop.vue?vue&type=script&lang=js"
export * from "./SettingAutoLikedTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports